var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(_vm._s(_vm.$t('Member no.')))]), _c('div', {
    staticClass: "text-[16px] text-right"
  }, [_c('a', {
    staticClass: "link !text-[#134B96] !font-semibold",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('switched');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Login with phone no.')))])])]), _c('el-form-item', {
    attrs: {
      "prop": "user"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.form.user,
      callback: function ($$v) {
        _vm.$set(_vm.form, "user", $$v);
      },
      expression: "form.user"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('Password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "show-password": ""
    },
    model: {
      value: _vm.form.password,
      callback: function ($$v) {
        _vm.$set(_vm.form, "password", $$v);
      },
      expression: "form.password"
    }
  })], 1), _c('el-form-item', [_c('el-button', {
    staticClass: "green-button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.submitForm('form');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Login')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };